import { cn } from '@/utils/cn';
import { BASE_MODAL, BASE_MODAL_HEIGHT_FIXED, BASE_MODAL_SIZE } from './utils';
import type { TBaseModalHeight, TBaseModalSize } from './base-modal.types';

const baseModalStyles = {
	overlay: cn(
		'fixed inset-0 bg-black/50 animate-[fadeIn_200ms_ease-out]',
		BASE_MODAL.OVERLAY_Z
	),
	content: (size: TBaseModalSize, height: TBaseModalHeight) =>
		cn(
			'fixed inset-0 m-auto outline-none h-fit max-h-[90vh]',
			'flex flex-col bg-white rounded-2xl shadow-[0_32px_56px_0_rgba(106,105,119,0.20)] animate-[modalIn_200ms_ease-out]',
			BASE_MODAL.CONTENT_Z,
			BASE_MODAL_SIZE[size],
			height === 'fixed' && BASE_MODAL_HEIGHT_FIXED[size]
		),
	header: 'flex items-start justify-between gap-6 px-6 pt-6 pb-6 shrink-0',
	headerCustomSlot: 'flex-1 min-w-0',
	title: 'flex-1 text-xl font-bold text-[#2e2e3a] leading-[1.3] font-[Figtree,sans-serif] m-0',
	closeButton:
		'flex items-center justify-center w-5 h-5 shrink-0 bg-transparent border-none rounded-lg cursor-pointer transition-colors hover:bg-[#f5f5fa] active:bg-[#e9e9f5] outline-none disabled:opacity-50 disabled:cursor-not-allowed',
	body: (scrollable: boolean) =>
		cn(
			'w-full text-sm font-normal text-[#2e2e3a] leading-[1.4] font-[Figtree,sans-serif] px-6 py-6',
			scrollable && 'flex-1 overflow-y-auto min-h-0'
		),
	footer:
		'flex items-center justify-end gap-2 px-6 py-4 shrink-0 border-t border-[#ededf5]',
	srOnlyDescription: 'sr-only',
	srOnlyTitle: 'sr-only'
} as const;

export { baseModalStyles };
